export function AmountFormat(number, currency) {
    // Convert number to a valid number type
    const numericValue = parseFloat(number);

    // Check if numericValue is a valid number
    if (!isNaN(numericValue)) {
        // Check if currency is Euro
        if (currency === "EUR") {
            // Convert number to string and split it into integer and decimal parts
            const [integerPart, decimalPart] = numericValue.toFixed(2).split(".");

            // Add dots every three digits in the integer part
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            // Combine integer and decimal parts with a comma
            return `${formattedInteger},${decimalPart}`;
        } else if (currency === "USD") {
            // Convert number to string and split it into integer and decimal parts
            const [integerPart, decimalPart] = numericValue.toFixed(2).split(".");

            // Add commas every three digits in the integer part
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and decimal parts with a dot
            return `${formattedInteger}.${decimalPart}`;
        }
    }

    // Return the number as it is if currency is not specified or unsupported
    return numericValue.toFixed(2);
}
